/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
const e="esri-time-zone-label",d={base:e,badge:`${e}__badge`,badgeDisabled:`${e}__badge--disabled`,badgeHidden:`${e}__badge--hidden`,badgeIcon:`${e}__badge-icon`,name:`${e}__name`,nameHidden:`${e}__name--hidden`,label:`${e}__label`,labelDisabled:`${e}__label--disabled`,labelHidden:`${e}__label--hidden`,expander:`${e}__expander`};export{d as css};
